import React from 'react';
import { Box } from '@zillow/constellation-10';
import BackButton from '../BackButton';
import NextButton from '../NextButton';

export default function IdvFooter() {
  return (
    <footer style={{ width: '100%' }}>
      <Box
        aria-label="Wizard steps navigation"
        css={{
          display: 'flex',
          marginTop: 'default',
          marginBottom: 'default',
          marginLeft: { base: 'default', lg: 'looser' },
          marginRight: { base: 'default', lg: 'looser' },
          justifyContent: 'space-between',
        }}
      >
        <span>
          <BackButton />
        </span>
        <span>
          <NextButton />
        </span>
      </Box>
    </footer>
  );
}
